var reactIs$1 = {exports: {}};

export { reactIs$1 as __module };
//# sourceMappingURL=index9.mjs.map
